import { useEffect, useState } from 'react';

export const useUnixCountdown = (targetUnixTime?: number | null) => {
  const [timeLeft, setTimeLeft] = useState(targetUnixTime ? targetUnixTime * 1000 - Date.now() : 0);

  useEffect(() => {
    if (!targetUnixTime) return;

    const interval = setInterval(() => {
      const diff = targetUnixTime * 1000 - Date.now();

      setTimeLeft(diff > 0 ? diff : 0);
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval);
  }, [targetUnixTime]);

  const hours = Math.floor(timeLeft / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  const isExpired = timeLeft <= 0;

  return {
    hours,
    minutes,
    seconds,
    isExpired
  };
};
